module.exports = __webpack_public_path__ + "static/media/phoenix.d1d55624.png";